import classNames from "classnames";
import React, { Component } from "react";
import "../../../../styles/main.scss";

interface KuikaTextProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode;
}

class KuikaText extends Component<KuikaTextProps> {
  render() {
    const { children, className, title, ...props } = this.props;
    // Native title only when it is meaningful: an explicit prop, or plain-string children (the
    // truncation affordance). Stringifying a ReactNode child produced a literal "[object Object]"
    // hover tooltip on every rich-label consumer (e.g. checkbox rows in dropdown menus).
    const resolvedTitle: string | undefined = title ?? (typeof children === "string" ? children : undefined);

    return (
      <span className={classNames("kuika-typography-text", className)} {...props} title={resolvedTitle}>
        {children}
      </span>
    );
  }
}

export default KuikaText;
